import { ActivityInput, ActivityType, Domain } from '../../graphql/generated/graphql.ts';
import { FC } from 'react';
import { Breadcrumbs, Card, CardContent, Typography } from '@mui/material';

export interface ActivityDisplayProps {
  activity: Partial<ActivityInput>;
  domain: Partial<Domain>;
}

const renderType = (type: ActivityType) => {
  switch (type) {
    case ActivityType.Pleasant:
      return 'Pleasant';
    case ActivityType.Meaningful:
      return 'Challenging / Meaningful';
    case ActivityType.Social:
      return 'Social Connection';
  }
};

export const ActivityDisplay: FC<ActivityDisplayProps> = ({ activity, domain }) => {
  return (
    <Card sx={{ backgroundColor: domain.color }}>
      <CardContent>
        <Typography variant="h5">{activity.description}</Typography>
        <Breadcrumbs separator="•">
          <Typography variant="subtitle1">{domain.title}</Typography>
          {activity.type && <Typography variant="subtitle1">{renderType(activity.type)}</Typography>}
        </Breadcrumbs>
        {activity.subgoal && <Typography variant="subtitle1">Sub Goal: {activity.subgoal}</Typography>}
      </CardContent>
    </Card>
  );
};
